import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const Container = styled.div`
  background-color: ${props => props.theme.colors.card};
  grid-area: CardSecondary;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04), 0 4px 24px rgba(0, 0, 0, 0.06);
  border: 1px solid ${props => props.theme.colors.border_grey}30;
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 24px;
  gap: 16px;

  @media (max-width: 576px) {
    padding: 20px;
  }
`;

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  flex: 1;
`;

export const IconBadge = styled.div<{ color: string }>`
  width: 40px;
  height: 40px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${props => props.color}14;
  color: ${props => props.color};
  margin-bottom: 4px;
`;

export const Title = styled.span`
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: ${props => props.theme.colors.grey_text};
`;

export const Value = styled.h2`
  color: ${props => props.theme.colors.text};
  font-size: 28px;
  font-weight: 700;
  letter-spacing: -0.02em;
  font-variant-numeric: tabular-nums;
  margin: 0;
  line-height: 1.2;
`;

export const SubTitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const Subtitle = styled.span`
  font-size: 11px;
  font-weight: 500;
  color: ${props => props.theme.colors.grey_text};
`;

export const SecondaryValue = styled.span`
  color: ${props => props.theme.colors.text};
  font-size: 15px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  letter-spacing: -0.01em;
`;

export const ActionButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px 20px;
  border-radius: 12px;
  border: none;
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
  transition: all 150ms ease;
  background-color: ${props => props.theme.colors.primary}14;
  color: ${props => props.theme.colors.primary};
  align-self: flex-start;

  &:hover {
    background-color: ${props => props.theme.colors.primary}24;
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }

  @media (max-width: 576px) {
    align-self: stretch;
    justify-content: center;
  }
`;

export const StyledLink = styled(Link)`
  text-decoration: none;
  align-self: flex-start;

  @media (max-width: 576px) {
    align-self: stretch;
  }
`;
